/* template */
<template><div class="cate-goods-list cate-goods-list_by_cate"><div v-for="(cate, cateIdx) in (goodsByCates)" :key="cate['{{ item.id }}']" class="cate"><cate-in-list :cate-name="(cate.name)"/><template v-for="(item, goodIdx) in (cate.goods)" v-if="(cate.goods && cate.goods.length)"><good-card :key="item['{{ item.good_id }}']" :good-info="(item)" shadow @good-click="onGoodClick(item)" class="good-card-item"/><div ref="sentinel" class="sentinel" v-if="(cateIdx === goodsByCates.length - 1 && (cate.goods.length > 3 ? goodIdx === cate.goods.length - 3 : goodIdx === 0 ))"/></template><div ref="sentinel" class="sentinel sentinel-block" v-if="(!cate.goods.length && cateIdx === goodsByCates.length - 1)"></div></div><loading v-if="(showLoading)"/><empty v-if="(!showLoading && isEmpty)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4bb590cf"}'>
.sentinel
  width 1px
  height 1px

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { TrackMap } from '../../../../lib/webx/common_methods/track_map'
import { MixinList } from '../mixin'

const NumberOfOnePage = 10

createComponent({
  name: 'AllByCateGoodsList',
  mixins: [ MixinList ],
  async attached() {
    this.innerCates = this.cates
      .filter(cate => cate.id !== 0)
      .map(cate => ({
        id: cate.id,
        name: cate.name,
        page: 1,
        finish: false,
      }))
    if (this.innerCates?.length >= 1) {
      await this.firstLoad()
      TrackMap.index.listGoodsExposed.call(this, this.goodsByCates.reduce((prev, curr) => {
        prev.push(...curr.goods)
        return prev
      },  []))
    }
  },
  properties: {
    cates: Array,
    hasRecommend: {
      type: Boolean,
      value: false,
    },
  },
  data: {
    innerCates: [],
    goodsByCates: [],
    allFinish: false,
    showLoading: false,
  },
  computed: {
    isEmpty() {
      return this.goodsByCates.reduce((prev, curr) => prev + curr.goods.length, 0) === 0
    },
  },
  methods: {
    async firstLoad() {
      this.showLoading = true
      const cate = this.innerCates[0].id
      await this.getByCate(cate)
      let total = this.goodsByCates.reduce((prev, cate) => cate.goods.length + prev, 0)
      let counter = 0
      while (total < NumberOfOnePage && !this.innerCates.every(cate => cate.finish) && counter <= this.innerCates.length * 2) {
        await this.loadMore({ fromFirstLoad: true })
        total = this.goodsByCates.reduce((prev, cate) => cate.goods.length + prev, 0)
        counter += 1
      }
      this.observeSentinel()
      this.showLoading = false
    },
    // 必须实现，翻页要用
    async loadMore({ fromFirstLoad = false } = {}) {
      if (this.allFinish) return
      this.showLoading = true
      const cateGoods = this.goodsByCates[this.goodsByCates.length - 1]
      const cateIndex = this.innerCates.findIndex(cate => cate.id === cateGoods.id)
      const cate = this.innerCates[cateIndex]
      if (!cate.finish) {
        await this.getByCate(cate.id)
      } else if (this.innerCates[cateIndex + 1]) {
        await this.getByCate(this.innerCates[cateIndex + 1].id)
      } else {
        this.allFinish = true
      }
      this.showLoading = false
      if (!fromFirstLoad) {
        this.observeSentinel()
        if (!this._loadMoreTrackCounter) {
          this._loadMoreTrackCounter = 1
        }
        if (this._loadMoreTrackCounter < 3) {
          TrackMap.index.nextPage({
            row_type: this._loadMoreTrackCounter,
          })
          this._loadMoreTrackCounter += 1
        }
      }
    },
    async getByCate(cateId) {
      const cate = this.innerCates.find(cate => cate.id === cateId)
      const { lists, count } = await this.$getGoodsByCates(cateId, cate.page) || {}
      const index = this.goodsByCates.findIndex(cate => cate.id === cateId)
      if (index > -1) {
        if (lists === undefined && count === undefined) {
          cate.finish = true
        } else {
          this.goodsByCates[index].goods.push(...(lists || []))
          cate.finish = this.goodsByCates[index].goods.length >= count
          cate.page += 1
        }
      } else {
        this.goodsByCates.push({
          id: cateId,
          name: this.cates.find(cate => cate.id === cateId)?.name,
          goods: lists || [],
        })
        if (lists === undefined && count === undefined) {
          cate.finish = true
        } else {
          cate.finish = lists?.length >= count
          cate.page += 1
        }
      }

    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "all_by_cate_goods_list4bb590cf",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'good-card':getComponent(require("../../../../../node_modules/@didi/trade-sdk/lib/quartz/ui/good_card/index.mpx?component=true&componentId=index4ce63343")),'loading':getComponent(require("./loading.mpx?component=true&componentId=loadingd8a157b0")),'cate-in-list':getComponent(require("./cate_in_list.mpx?component=true&componentId=cate_in_list57520d6c")),'empty':getComponent(require("./empty.mpx?component=true&componentId=empty04f86cf9"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
